import { Tab, Tabs } from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useReservationStyles } from "../../../assests/styles/views/Reservations/reservationStyles";
import { getTranslation } from "../../../heplers/translationHelper";

const ReservationNavTabs = () => {
  const history = useHistory();
  const [selectedTab, setSelectedTab] = useState("current");
  const classes = useReservationStyles();
  const handleChange = (event, val) => {
    setSelectedTab(val);
    history.push(`/reservations/${val}`);
  };
  return (
    <Tabs
      value={selectedTab}
      onChange={handleChange}
      textColor="primary"
      indicatorColor="primary"
      aria-label="secondary tabs example"
      className={classes.tabs}
    >
      <Tab value="current" label={getTranslation("Current")} />
    </Tabs>
  );
};

export default ReservationNavTabs;
